<div class="contextmenu__item" [ngClass]="isActive ? 'active' : ''" (click)="outputValue(item)">
  <ng-content></ng-content> {{item[key]}}
</div>
